import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BehaviorSubject, Observable} from 'rxjs';
import {AnalyticsService} from '../../shared/analytics.service';
import {ApiService, HttpError} from '../../shared/api.service';
import {AuthService} from '../../shared/auth.service';
import {NavigationService} from '../../shared/navigation.service';
import {pluck} from 'rxjs/operators';

@Component({
  selector: 'register-confirm',
  templateUrl: './register-confirm.component.html',
  styleUrls: ['./register-confirm.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegisterConfirmComponent implements OnInit {

  code$: Observable<string>;
  expired$ = new BehaviorSubject(false);

  constructor(private Api: ApiService,
              private Navigation: NavigationService,
              private Analytics: AnalyticsService,
              private Auth: AuthService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    if (this.Auth.hasAuthentication()) {
      this.Navigation.goHome(true);
      return;
    }

    this.code$ = this.route.params.pipe(pluck('code'));
    this.confirmRegistration();
  }

  get code(): string {
    return this.route.snapshot.paramMap.get('code');
  }

  confirmRegistration() {
    this.Api.checkRegistration(this.code).subscribe(() => {
      this.refreshUser();
    }, (err: HttpError) => {
      this.handleRegistrationError(err);
    });
  }

  refreshUser() {
    this.Api.refreshUser()
      .subscribe(() => {
        if (!this.Auth.isFullyAuthenticated()) {
          this.Analytics.trackEvent('Confirm: Account confirmation failed');
          this.Navigation.handleError();
        } else {
          this.Analytics.trackEvent('Confirm: Account confirmation succeeded');
          this.Navigation.goHome(true);
        }
      }, (err: HttpError) =>
        this.Navigation.handleError(err));
  }

  handleRegistrationError(err: HttpError) {
    if (err.code === 'invalid_code') {
      this.Analytics.trackEvent('Confirm: Activation code invalid');
      this.Navigation.handleNotFound();
    } else if (err.code === 'expired_code') {
      this.Analytics.trackEvent('Confirm: Activation code expired');
      this.expired$.next(true);
    } else if (err.code === 'already_registered') {
      this.Analytics.trackEvent('Confirm: Already registered');
      this.Navigation.handleLogin(true, {registered: true});
    } else {
      this.Analytics.trackEvent('Confirm: Account activation failed', {category: 'Error'});
      this.Navigation.handleError(err);
    }
  }

}
